import { memone, MutableRecordStore, MutableSetStore } from '@deqo/foundation';
import { HangoutClient } from './HangoutClient';
import { HangoutLocation } from './HangoutLocation';

export type HangoutLocationVisit = readonly [string, number];

const template = {
    name: '',
    photo: '',
    color: '',
    location: null as HangoutLocation,
    clients: new Set<HangoutClient>(),
    online: false
};

export class HangoutUser extends MutableRecordStore(template) {

    constructor(public readonly id: string) {
        super();
    }

    protected useHooks(): void {
        this.hooks.push(x => {
            x.online = x.clients.size > 0;
        });
    }
}

export class HangoutUserStore extends MutableSetStore<HangoutUser> {

    public get(id: string) {
        return this.getMemoizedIndex(this.state).get(id) || null;
    }

    public reset() {
        this.mutateTo(new Set());
    }

    @memone()
    private getMemoizedIndex(state: Set<HangoutUser>) {
        const index = new Map<string, HangoutUser>();
        for (const hu of state) {
            index.set(hu.id, hu);
        }
        return index;
    }
}
